import { render, staticRenderFns } from "./shipWorks.vue?vue&type=template&id=eedfabe4&scoped=true"
import script from "./shipWorks.vue?vue&type=script&lang=js"
export * from "./shipWorks.vue?vue&type=script&lang=js"
import style0 from "./shipWorks.vue?vue&type=style&index=0&id=eedfabe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eedfabe4",
  null
  
)

export default component.exports